import { ENV } from "./configs";

export const ASK_FLASHDICE_API_ENDPOINT = ENV.ask_flashdice_api_endpoint;
export const ASK_FLASHDICE_MESSAGE_STAGGER_DELAY = 300;
export const ASK_FLASHDICE_MAX_NODES = ENV.max_nodes;

// Categorized example queries by complexity
export const EXAMPLE_QUERIES = {
  simple: [
    "list all products with their manufacturer names",
    "products with their generic status",
    "list products by corporation",
  ],
  medium: [
    "show me monthly sales by country name",
    "show sales data by market level",
    "sales value in local currency by product",
  ],
  complex: [
    "sales value by product and country name",
    "top products by sales value across all countries",
  ],
};

// Flattened array for backward compatibility
export const EXAMPLE_QUERIES_FLAT = [
  ...EXAMPLE_QUERIES.simple,
  ...EXAMPLE_QUERIES.medium,
  ...EXAMPLE_QUERIES.complex,
];
